

import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class RedirectGuard implements CanActivate {
    currentPath: any;
    constructor(private router: Router, private authService: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        this.currentPath = route.routeConfig.path;
        return this.verifyLoggedIn();
    }

    verifyLoggedIn(): boolean {
        const isLoggedIn = this.authService.isLoggedIn();
        if (isLoggedIn && this.currentPath.indexOf('verify') < 0) {
            this.router.navigate(['/member']);
            return false;
        }
        return true;
    }
}
